export default __webpack_public_path__ + "static/media/PANNEAU EXPLICATIF.700cc50b.svg";